import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnChooserService, FilterService, GridComponent, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs, FilterSettingsModel, SearchSettingsModel, TextWrapSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';

import { EligibilityReportService } from '../../service/eligibility-report.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
// import { CommonApiService } from '@services/commonapiservice';


import { EligibilityDetailsComponent } from '../eligibility-details/eligibility-details.component';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { ColumnChangeBO, columnWidth } from '../icd10/icd10.model';
import { CommonApiService } from 'src/app/service/commonapiservice';
import { EDI271BO } from '../eligibility-logs/eligibility-logs-model';
import { GeneralService } from 'src/app/service/general.service';
import { GetEDI271ClientBO } from '../client-parent/client-parent.model';

@Component({
  selector: 'app-eligibility-report',
  templateUrl: './eligibility-report.component.html',
  styleUrls: ['./eligibility-report.component.scss']
})
export class EligibilityReportComponent implements OnInit {
  @Input() DataFromList: GetEDI271ClientBO = new GetEDI271ClientBO();
  private onDestroy$: Subject<void> = new Subject<void>();
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  EDI271Client: GetEDI271ClientBO = new GetEDI271ClientBO();
  public toolbar: ToolbarItems[];
  public searchSettings: SearchSettingsModel;
  public wrapSettings: TextWrapSettingsModel;
  @ViewChild('grid') public grid: GridComponent;
  temphide: any = [];
  filterOptions: FilterSettingsModel;
  initialPage: object;
  height: string = "200px";
  datalength: number = 0
  getClientListerr: any = ""
  isDatashowfilter: boolean = false;
  public formatOptions: object;
  eligiblitydropdata: any = ["true", "false"];
  ISViewDetails: boolean = false;
  EligibleId: number = 0;
  viewFiles271: boolean = false;
  edi271list: EDI271BO[] = [];;
  @Output() Event = new EventEmitter<GetEDI271ClientBO>();
  constructor(public datepipe: DatePipe, public global: GlobalComponent, 
    public general: GeneralService,  public eligibilityservice: EligibilityReportService, public router: Router, public toastrService: ToastrService, private ref: ChangeDetectorRef,
    public CommonAPI: CommonApiService,) {
    this.data = eligibilityservice;
    // console.log('EligibilityReportComponent loaded');
  }
    //...........................................ngOnChanges................................................................
  ngOnChanges() {
  }
  ngOnInit(): void {
    // Use DataFromList for all logic
    if (!this.DataFromList) {
      this.DataFromList = new GetEDI271ClientBO();
    }
    this.toolbar = ['ColumnChooser'];
    this.initialPage = { currentPage: 1, pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: 10 }
    this.wrapSettings = { wrapMode: 'Content' };
    this.DataFromList.pageitem = 10;
    this.filterOptions = { type: 'Menu' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.getEligiblityDetails();
  }

  getEligiblityDetails() {
    // Use DataFromList.locationId directly
    this.eligibilityservice.ouputValues(this.DataFromList);
    let val = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if ((data != null && data.result.length > 0)) {
        this.isDatashowfilter = true;
      }
      else {
        this.isDatashowfilter = false;
      }
      val++;
      if (data != null && data != undefined && val == 1) {
       // this.getColumnwidth();
        if (data.result.length > 15) {
          this.grid.height = '500';
        }
        else {

          this.grid.height = 'auto';
        }
      }
    })

  }
  //...........................................dataStateChange................................................................
  public dataStateChange(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.DataFromList.orderColumn = state.sorted[0].name;
        this.DataFromList.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      
      if (this.DataFromList.type == "number") {


        this.DataFromList.value = state.action.currentFilterObject.value.toString();
        this.DataFromList.field = state.action.currentFilterObject.field;


      }
      else if (this.DataFromList.type == "date") {
        this.DataFromList.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.DataFromList.field = state.action.currentFilterObject.field;
      }
      else {
        this.DataFromList.value = state.action.currentFilterObject.value;
        this.DataFromList.field = state.action.currentFilterObject.field;





        this.DataFromList.matchCase = state.action.currentFilterObject.matchCase;
        this.DataFromList.operator = state.action.currentFilterObject.operator;

      }
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.DataFromList.field = "ClientName";
        this.DataFromList.matchCase = false;
        this.DataFromList.operator = "contains";
        this.DataFromList.value = "";
        this.DataFromList.type = "string"
        // this.EDI271Client.statusLid = this.ClientStatus[0].Key
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].EDI271Client.Pagesize != state.take) {
          this.arraycol[0].EDI271Client.Pagesize = state.take
          //this.SaveColumnwidth();
          // }

        }

      }

    }
    this.getEligiblityDetails();
  }
  //...........................................onActionComplete................................................................
  public onActionComplete(args) {
    this.DataFromList.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.DataFromList.pageitem = this.grid.pagerModule.pagerObj.pageSize;


    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.DataFromList.type = args.columnType

    }


  }
   //...........................................show................................................................
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50); // give X and Y axis
  }
    //...........................................validatebutton................................................................
  validatebutton(args) {
    if (args.column.field == "checkeligibility") {

    

    }

  }
  //...........................................getColumnwidth................................................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].EDI271Client.Columns;
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].EDI271Client.Pagesize;
    this.ColumnArray.forEach(element => {
      if (element.column == 'Name') {
        const column = this.grid.getColumnByField('clientName'); 
        column.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Medicaid') {
        const column = this.grid.getColumnByField('medicaid');
        column.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'DOB') {
        const column1 = this.grid.getColumnByField('dob'); 
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'PMAP') {
        const column1 = this.grid.getColumnByField('pmap'); 
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Program') {
        const column1 = this.grid.getColumnByField('program'); 
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Plan') {
        const column1 = this.grid.getColumnByField('planDescription'); 
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Waiver') {
        const column1 = this.grid.getColumnByField('waiver'); 
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'SpendDown') {
        const column1 = this.grid.getColumnByField('spendDown'); 
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'MSHO') {
        const column1 = this.grid.getColumnByField('msho'); 
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Messages') {
        const column1 = this.grid.getColumnByField('messages'); 
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'MA Eligible') {
        const column2 = this.grid.getColumnByField('isMAEligible'); 
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Action') {
        const column2 = this.grid.getColumnByUid('action'); 
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Plans End Date') {
        const column2 = this.grid.getColumnByField('planEnd'); 
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Benefit End Date') {
        const column2 = this.grid.getColumnByField('benefitEnd'); 
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();
      }
    });
  }
    //...........................................SaveColumnwidth................................................................
  SaveColumnwidth() {
    this.arraycol[0].EDI271Client.Columns = this.ColumnArray;
    this.arraycol[0].EDI271Client.Pagesize = this.grid.pageSettings.pageSize;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();
    });
  }
    //...........................................onResize................................................................
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }

    });
   // this.SaveColumnwidth();
    }
  }
  //...........................................viewlasteb................................................................
  viewlasteb(id) {
    this.EligibleId = id;
    this.ISViewDetails = true;
    document.getElementById('openModal7').click();
  }
  //...........................................closeViewdetails................................................................
  closeViewdetails() {
    this.ISViewDetails = false;
    document.getElementById('openModal7').click();
  }
  //...........................................print................................................................
print() {
  let url = "api/Claims/GetEligibilitySummaryListToPrint";
  this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.DataFromList,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    let Printdata = data;
    document.getElementById('printalertOpen').click();
    var a = window.open('', '', 'height=700, width=700');
    a.document.write('<html>')
    a.document.write('<head><meta name="viewport" content="width=device-width, initial-scale=1"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></head>');
    a.document.write('<body ><table class="table table-hover table-bordered table-responsive" style="margin-top: 5px;margin-left: 10px;border:solid #000 !important; border-width:1px 0 0 1px !important;">');
    a.document.write('<thead>');
    a.document.write('<th style="border:solid #000 !important;border-width:0 1px 1px 0 !important;border-top:1px">Name</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">DOB</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Medicaid</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">MA Eligible</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Plans End Date</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Benefit End Date</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Last Eligibility Check</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">PMAP</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Program</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Plan</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">Waiver</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">SpendDown</th>');
    a.document.write('<th  style="border:solid #000 !important;border-width:0 1px 1px 0 !important;">MSHO</th>');
    a.document.write('</thead>');
    a.document.write('<tbody>');
    let count=0;
    Printdata.forEach(element => {
      count++;
      a.document.write('<tr style="border:solid #000 !important; border-width:1px 0 0 1px !important;">');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.clientName + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' +this.datepipe.transform(element.dob, "MM/dd/yyyy") + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + element.medicaid + '</td>');
      if (element.isMAEligible) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-check-circle" ></i></td>');
      }
      else if (element.isMAEligible == false) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-times-circle-o"></i></td>');
      }
      else if (element.isMAEligible == null) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"></td>');
      }
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + ((element.planEnd!=null&&element.planEnd!=undefined&&element.planEnd!='')?this.datepipe.transform(element.planEnd, "MM/dd/yyyy"):'') + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + ((element.benefitEnd!=null&&element.benefitEnd!=undefined&&element.benefitEnd!='')?this.datepipe.transform(element.benefitEnd, "MM/dd/yyyy"):'') + '</td>');

      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.lastEligibilityCheck == null ? "" : this.datepipe.transform(element.lastEligibilityCheck, "MM/dd/yyyy")) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.pmap == null ? "" : element.pmap) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.program == null ? "" : element.program) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.planDescription == null ? "" : element.planDescription) + '</td>');
      a.document.write(' <td style="text-align: left;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;">' + (element.waiver == null ? "" : element.waiver) + '</td>');
      if (element.spendDown) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-check-circle" ></i></td>');
      }
      else if (element.spendDown == false) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-times-circle-o"></i></td>');
      }
      else if (element.spendDown == null) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"></td>');
      }
      if (element.msho) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-check-circle" ></i></td>');
      }
      else if (element.msho == false) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"><i class="fa fa-times-circle-o"></i></td>');
      }
      else if (element.msho == null) {
        a.document.write(' <td style="text-align: center;font-weight: 600;border:solid #000 !important;border-width:0 1px 1px 0 !important;"></i></td>');
      }
      a.document.write('</tr>');
    });
    a.document.write(' </tbody>  </table>');
    a.document.write('</body></html>');
    a.document.close();
    let interval=setInterval(()=>{
      if(count==Printdata.length)
      {
        setTimeout(() => {
          a.print()
        }, 1000);
        clearInterval(interval);
      }
    },100)
  },
  (err: HttpErrorResponse) => {
      this.toastrService.error(err?.error, 'error')
    });
}
    //...........................................closeprint................................................................
  closeprint() {
    document.getElementById('printalertOpen').click();
  }
    //...........................................showColumn................................................................
  showColumn() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
}
  //...........................................printDifferenceReport................................................................
  printDifferenceReport() {
    let trueIcon = `<i class="fa fa-check-circle"></i>`, falseIcon = `<i class="fa fa-times-circle-o"></i>`,
      nullIcon = ``;
      let url = "api/Claims/getEligibilityDifferenceList";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.DataFromList,url).pipe(takeUntil(this.onDestroy$)).subscribe((printdata: any) => {
      document.getElementById("differenceReportPrintAlertSpan").click();
      var a = window.open('', '', 'height=700, width=700');
      a?.document.write(`
      <html>
      <head>
      <meta name="viewport" content="width=device-width, initial-scale=1"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
      <style>
      table, th, td {
        border: 1px solid black;
        border-collapse: collapse;
      }
      </style>
      </head>
      <body>
      <table class="table table-hover table-bordered table-responsive">
      <thead>
        <th >Name</th>
        <th >Eligibility Check</th>
        <th >Plans End Date</th>
        <th >Benefit End Date</th>
        <th >MA Eligible</th>
        <th >PMAP</th>
        <th >Program</th>
        <th >Plan</th>
        <th >Waiver</th>
        <th >SpendDown</th>
        <th >MSHO</th>
      </thead>
      <tbody>
      `);
      let count=0;
      printdata.forEach(eligibilityClient => {
        a?.document.write(`
        <tr>
        <td rowspan=`+ (eligibilityClient.eligibilitySummaryList.length + 1).toString() + `>` + eligibilityClient.clientName + `</td>
        </tr>
        `);
        eligibilityClient.eligibilitySummaryList.forEach(eligibilitySummary => {
          a?.document.write(`
          <tr>
          <td>`+ this.datepipe.transform(eligibilitySummary.eligibilityCheckDate, "MM/dd/yyyy") + `</td>` + `
          <td>`+ this.datepipe.transform(eligibilitySummary?.planEnd, "MM/dd/yyyy") + `</td>` + `
          <td>`+ this.datepipe.transform(eligibilitySummary?.benefitEnd, "MM/dd/yyyy") + `</td>` + `
          <td style="text-align: center;">`+ (eligibilitySummary.isMAEligible == true ? trueIcon : eligibilitySummary.isMAEligible == false ? falseIcon : nullIcon) + `</td>` + `
          <td>`+ (eligibilitySummary.pmap ?? "") + `</td>` + `
          <td>`+ (eligibilitySummary.program ?? "") + `</td>` + `
          <td>`+ (eligibilitySummary.planDescription ?? "") + `</td>` + `
          <td>`+ (eligibilitySummary.waiver ?? "") + `</td>` + `
          <td style="text-align: center;">`+ (eligibilitySummary.spendDown == true ? trueIcon : eligibilitySummary.spendDown == false ? falseIcon : nullIcon) + `</td>` + `
          <td style="text-align: center;">`+ (eligibilitySummary.msho == true ? trueIcon : eligibilitySummary.msho == false ? falseIcon : nullIcon) + `</td>` + `
          </tr>
          `)
        });
      });

      a?.document.write(`
      </tbody> 
      </table>
      </body>
      </html>
      `);
      a?.document.close();
      let interval=setInterval(()=>{
        if(count==printdata.length)
        {
         
         
          setTimeout(() => {
            a.print()
          }, 1000);
          clearInterval(interval);
        }
      },100)
    })
  }
    //...........................................closeDifferenceReportPrintAlert................................................................
  closeDifferenceReportPrintAlert() {
    document.getElementById('differenceReportPrintAlertSpan').click();
  }
   //......................................exportEligibilitysWithPaginationCsv.....................................................
   exportEligibilitysWithPaginationCsv() {
    this.DataFromList.pageitem = this.grid.pageSettings.pageSize;
    this.DataFromList.currentpageno = this.grid.pageSettings.currentPage;
    let url = "api/Claims/GetEligibilitySummaryListCurrentPageCSV";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.DataFromList,url,"EligibilityReport.csv");
  }
  //...........................................exportEligibiltyCsv................................................................
  exportEligibiltyCsv() {

    let url = "api/Claims/GetEligibilitySummaryListAllPageCSV";
      this.CommonAPI.saveorUpdateFunctionFileSaver(this.DataFromList,url,"EligibilityReport.csv"); 

  }

    //...........................................closecsvmodal................................................................
  closecsvmodal(){
    document.getElementById('exportascsv').click();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

